import {ApiClientService, EntityApiService} from '@dofleini/security';

class RunAuditSyncService extends EntityApiService {

    syncAudits = (params) => {
      const {url, data, method, isBlob, headers} = params;
      switch (method) {
        case 'post':
          return ApiClientService.post(url, data, isBlob && {headers});
        case 'patch':
          return ApiClientService.patch(url, data);
        case 'delete':
          return ApiClientService.delete(url, data);
        default:
          return ApiClientService.get(url, data);
      }
    }

}

export default new RunAuditSyncService('/ms-core/api/');
